<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div v-if="!loading">
                    <div class="pb-2">
                        <p>
                            <b>Customer:</b> {{order.registeredCompanyName}}
                        </p>
<!--                        <p v-if="order.customerBranch">-->
<!--                            Branch: {{order.customerBranch}}-->
<!--                        </p>-->
                        <p>
                            <b>Order Date:</b> {{order.insertedOn}}
                        </p>
                        <p>
                            <b>Order Type:</b> {{order.orderType}}
                        </p>
                        <p>
                            <b>Order Status:</b> {{order.description}}
                        </p>
<!--                        <p v-if="order.placedBy">-->
<!--                            Placed By: {{order.placedBy}} (#{{order.placedByUserId}})-->
<!--                        </p>-->
                        <p v-if="order.expectedDeliveryDate !== null && order.expectedDeliveryDate !== undefined">
                            <b>Expected Date Of Delivery:</b> {{order.expectedDeliveryDate}}
                        </p>
                    </div>
                    <div class="card border border-secondary mb-3">
                        <div class="card-body text-secondary">
                            <div class="row">
                                <div class="col-6">
                                    <h5 class="card-title text-secondary">Billing Address</h5>
                                    <p v-if="!loadingBillingAddress">
                                        <span v-if="billingAddress">
                                            {{ billingAddress.siteName }}<br>
                                            {{ billingAddress.streetAddress }}<br>
                                            {{ billingAddress.city }} <br>
                                            {{ billingAddress.province }} <br>
                                            {{ billingAddress.postalCode }}<br>
                                            <!--                                {{ billingAddress.country }}-->
                                        </span>
                                                <span v-else>
                                            No billing address found.
                                        </span>
                                    </p>
                                    <p v-if="loadingBillingAddress">Loading...</p>
                                </div>
                                <div class="col-6">
                                    <h5 class="card-title text-secondary">Shipping Address</h5>
                                    <p v-if="!loadingBillingAddress">
                                        <span v-if="shippingAddress">
                                            {{ shippingAddress.siteName }}<br>
                                            {{ shippingAddress.streetAddress }}<br>
                                            {{ shippingAddress.city }} <br>
                                            {{ shippingAddress.province }} <br>
                                            {{ shippingAddress.postalCode }}<br>
                                            <!--                                {{ billingAddress.country }}-->
                                        </span>
                                        <span v-else>
                                            No shipping address found.
                                        </span>
                                    </p>
                                    <p v-if="loadingBillingAddress">Loading...</p>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <div class="card border border-secondary pt-2">
                        <div class="card-body text-secondary">
                            <h5 class="card-title text-secondary">Items Ordered</h5>
                            <order-items-table
                                :orderId="orderId"
                                :orderTotal="orderGrandTotal"></order-items-table>
                        </div>
                    </div>
                    <br>
                    <div class="text-danger" v-if="acceptOrder.hasError">
                        {{acceptOrder.errorMessage}}
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="orderTypeRadios" id="acceptRejectOrderRadios1" :value="true" v-model="acceptOrder.value"
                               >
                        <label class="form-check-label" for="acceptRejectOrderRadios1">
                            Accept Order
                        </label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="orderTypeRadios" id="acceptRejectOrderRadios2" :value="false" v-model="acceptOrder.value"
                        >
                        <label class="form-check-label" for="acceptRejectOrderRadios2">
                            Reject Order
                        </label>
                    </div>
                    <br>
                    <div class="form-group">
                        <label for="reasonInput">
                            Notes
                        </label>
                        <textarea class="form-control" id="reasonInput" v-model="notes" rows="4" cols="50"></textarea>
                    </div>
                    <button class="btn btn-primary" @click="validateAcceptOrRejectOfOrder">Save</button>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>

    <success-modal
            :modalHeading="successModal.modalHeading"
            :elementId="'reviewOrderSuccessModal'"
            :modalMessage="successModal.modalMessage"
            :showModal="successModal.showModal"
            @okClicked="onSuccessModalOkClick">

    </success-modal>
</div>
